import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { RegisteredRetailer } from 'src/app/models/registered-retailer.model';
import { OtpService } from 'src/app/service/otp.service';
import { RetailerDataStoreService } from 'src/app/service/retailer-data-store.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-existing-dealer',
  templateUrl: './existing-dealer.component.html',
  styleUrls: ['./existing-dealer.component.scss']
})
export class ExistingDealerComponent {

  dealers: RegisteredRetailer[] = [];
  isLoading: boolean = false; 
  phoneNumber: string = '';
  isEditFlow: boolean = false;

  constructor(
      private router: Router,
      private retailerDataStore: RetailerDataStoreService,
      private otpService: OtpService,
      private snackBar: MatSnackBar,
      private location: Location
    ) {
      const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state && navigation.extras.state['dealers']) {
      this.dealers = navigation.extras.state['dealers'];
      this.phoneNumber = navigation.extras.state['phoneNumber'] || '';
      this.isEditFlow = navigation.extras.state['isEditFlow'] || false;
    }
  }

  generateOtpAndProceed(): void {
    this.isLoading = true;

    this.otpService.generateOtp(this.phoneNumber).subscribe(
      response => {
        this.isLoading = false;
        if (response && response.metaData.responseCode === 'OK') {
          this.router.navigate(['/verify-otp'], {
            queryParams: {
              phoneNumber: this.phoneNumber,
              isEditFlow: this.isEditFlow
            }
          });
        } else {
          this.snackBar.open(response?.metaData.responseCode || 'Failed to send OTP. Please try again.', 'Dismiss', { duration: 5000 });
          console.error('API response for OTP generation failed:', response);
        }
      },
      error => {
        this.isLoading = false;
        this.snackBar.open(error.error?.metaData.responseCode === 'TOO_MANY_REQUESTS' ? 'Too many requests. Please try after 5 minutes.' : 'An error occurred while sending OTP. Please try again later.', 'Dismiss', { duration: 5000 });
        console.error('Error generating OTP:', error);
      }
    );
  }

  selectExistingRetailer(retailer: RegisteredRetailer): void {
    this.retailerDataStore.setRetailer(retailer);
    this.router.navigate(['/view-dealer-details'], { state: { dealer: retailer } });
  }

  goBack(): void {
    this.location.back();
  }
}
